var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConsultPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1707481657"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 525",
    cx: 30,
    cy: 30,
    r: 30,
    fill: "var(--fill-0, #EEE0AF)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "031.call"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.2153 25.1815L26.0453 27.3631C26.9326 28.6502 27.9363 29.8531 29.0437 30.9565C30.1511 32.0641 31.3578 33.0677 32.6487 33.9548L34.8187 31.7848C35.0373 31.5675 35.333 31.4455 35.6412 31.4455C35.9494 31.4455 36.2451 31.5675 36.4637 31.7848L40.5937 35.9148C40.811 36.1334 40.9329 36.4291 40.9329 36.7373C40.9329 37.0455 40.811 37.3412 40.5937 37.5598L39.707 38.4465L37.8987 40.2548C37.5761 40.5755 37.1669 40.795 36.7212 40.8862C36.2756 40.9774 35.813 40.9364 35.3903 40.7681C34.3947 40.3433 33.4212 39.8682 32.4737 39.3448C30.0058 37.9681 27.7404 36.2563 25.742 34.2581C23.7421 32.2614 22.03 29.9957 20.6553 27.5265C20.1296 26.5801 19.6545 25.6065 19.232 24.6098C19.0652 24.1861 19.0261 23.7228 19.1193 23.2771C19.2126 22.8314 19.4343 22.4227 19.757 22.1015L21.5537 20.3048L22.4403 19.4065C22.5488 19.2971 22.6778 19.2103 22.82 19.1511C22.9622 19.0919 23.1147 19.0614 23.2687 19.0614C23.4227 19.0614 23.5752 19.0919 23.7174 19.1511C23.8595 19.2103 23.9886 19.2971 24.097 19.4065L28.2153 23.5365C28.4326 23.7551 28.5546 24.0507 28.5546 24.359C28.5546 24.6672 28.4326 24.9629 28.2153 25.1815Z",
    fill: "var(--fill-0, #48AFBA)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultPhone);
export default __webpack_public_path__ + "static/media/consult-phone.97b45a61039823e84a6c589bda990820.svg";
export { ForwardRef as ReactComponent };